<template>
	<div>
		<v-tabs v-model="activeTab" background-color="transparent" centered slider-color="yellow">
			<v-tab :key="0">بکاپ گیری</v-tab>
			<v-tab :key="1">بازگردانی بکاپ</v-tab>

			<v-tabs-items v-model="activeTab" touchless>
				<v-tab-item :key="0">
					<v-form ref="form" class="mx-2" lazy-validation>
						<v-row>
							<v-col cols="12" md="12" class="text-center">
								<div class="mb-2">جهت تهیه بکاپ، دکمه ایجاد بکاپ را بزنید:</div>
								<v-btn class="" dark small :loading="createLoading" color="green" title="تهیه بکاپ" @click="createBackup()">
									<v-icon dark>
										mdi-package-up
									</v-icon>
									ایجاد بکاپ
								</v-btn>
							</v-col>
						</v-row>
						<br />
						<hr />
						<v-row>
							<v-col cols="12" md="12">
								<div class="mb-3 text-center">لیست بکاپ های موجود:</div>
								<v-data-table dense :headers="headers" :loading="loading" loading-text="در حال دریافت اطلاعات..." :items="backups" :items-per-page="20" class="elevation-1">
									<template v-slot:item="row">
										<tr>
											<td class="text-center">{{ row.item.fileName }}</td>
											<td class="text-center">{{ row.item.createDate }}</td>
											<td class="text-center">{{ row.item.fileSize }}</td>
											<td class="text-center">
												<v-btn class="mx-1" fab dark small color="green" title="دانلود" @click="download(row.item)">
													<v-icon dark>
														mdi-download
													</v-icon>
												</v-btn>
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-col>
						</v-row>
					</v-form>
				</v-tab-item>
				<v-tab-item :key="1">
					<v-form ref="form2" lazy-validation>
						<v-row align="center" justify="center" class="mt-3">
							<v-col cols="12" sm="6">
								<v-file-input ref="file" v-model="file" :rules="[value => !!value || 'ابتدا فایل را انتخاب کنید.']" accept="zip" placeholder="" prepend-icon="mdi-file-excel-outline" label="جهت انتخاب فایل اینجا را کلیک کنید" />
							</v-col>
							<v-col cols="12" sm="2">
								<v-btn color="info" dark :loading="loading" @click="startRestore">
									<v-icon dark>
										mdi-upload
									</v-icon>
									شروع بازگردانی
								</v-btn>
							</v-col>
						</v-row>
					</v-form>
				</v-tab-item>
			</v-tabs-items>
		</v-tabs>
	</div>
</template>

<script>
	import { get } from 'vuex-pathify'
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'BackupView',
		props: {
			data: { type: Object },
		},
		data() {
			return {
				file: null,
				activeTab: 0,
				createLoading: false,
				loading: false,
				errorMessages: '',
				localData: {},
				headers: [
					{
						text: 'نام فایل',
						align: 'center',
						sortable: true,
						value: 'fileName',
					}, {
						text: 'تاریخ ایجاد',
						align: 'center',
						sortable: true,
						value: 'createDate',
					}, {
						text: 'حجم فایل',
						align: 'center',
						sortable: true,
						value: 'fileSize',
					},
					{
						text: 'دانلود',
						align: 'center',
						sortable: false,
						value: 'fileSize',
					},
				],
				backups: [],
				show1: false,
				show2: false,
			}
		},
		computed: {
			...get('auth', [
				'getCurrentUser',
			]),
			purchased() {
				return this.getCurrentUser?.userData?.customer?.purchased
			},
		},
		mounted() {
			this.loadData()
		},
		methods: {
			createBackup() {
				if (!this.purchased) {
					console.log('aaaaa')
					toast.error("قابلیت بکاپ گیری در نسخه آزمایشی در دسترس نمی باشد.")
					return
				}
				this.createLoading = true
				api.post('admin/backup/create', null)
					.then(
						response => {
							this.loadData()
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.createLoading = false
					})
			},
			download(item) {
				const a = document.createElement('a')
				a.style.display = 'none'
				a.href = `/backups/${item.fileName}`
				document.body.appendChild(a)
				a.click()
				document.body.removeChild(a)
			},
			loadData() {
				this.loading = true
				api.get('admin/backup/list', null)
					.then(
						response => {
							this.backups = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			startRestore() {
				if (!this.purchased) {
					toast.error("قابلیت بازیابی بکاپ در نسخه آزمایشی در دسترس نمی باشد.")
					return
				}
				if (!this.$refs.form2.validate()) { return }
				const formData = new FormData()
				formData.append('file', this.file)
				this.loading = true
				api.post('admin/backup/Restore', formData, { contentType: 'multipart/form-data' })
					.then(response => {
						toast.success('بکاپ با موفقیت بازگردانی شد.')
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			}
		},
	}
</script>
<style>
</style>
